import { ShippingMethodCode, ShippingMethod } from '@/store/models';
import store from '@/store';

export function decode(methodCode: string): ShippingMethodCode {
    const exploded = methodCode.split('_');
    let code = exploded[1];
    if (exploded.length > 2) {
        let i = 2;
        while (i < exploded.length) {
            code += '_' + exploded[i];
            i++;
        }
    }
    return {
        carrier_code: exploded[0],
        method_code: code,
    };
}

export function encode(method: ShippingMethodCode): string {
    return method.carrier_code + '_' + method.method_code;
}

export function getSimilarMethod(method: ShippingMethod, shippingMethods: ShippingMethod[]): false|ShippingMethodCode {
    const multicarrier = store.state.options.carrier.multicarrier;
    let found;
    if (multicarrier) {
        found = shippingMethods.find((m) => {
            return m.method_title === method.method_title;
        });
    } else {
        found = shippingMethods.find((m) => {
            return m.carrier_code === method.carrier_code;
        });
    }
    return found ? found : false;
}

export function isRuPickupMethod(method: ShippingMethod): boolean {
    return method.method_title === 'Shipping pickup' || method.method_title === 'ДОСТАВКА В ПУНКТ САМОВЫВОЗА';
}
